import React, { useState, useEffect, useRef } from "react";
import { isMobile } from "react-device-detect";
import YouTube from "react-youtube";
import ReactPlayer from 'react-player/lazy'
import { isMobileOnly, isTablet, isDesktop } from "react-device-detect";

const PlayVideo = (props) => {
    const vidRef = useRef(null);
    const [muted, setMuted] = useState(false); 
    const [render, setRender] = useState(false); 
    const saysWho = () => {
        const { userAgent } = navigator
        let match = userAgent.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || []
        let temp
      
        if (/trident/i.test(match[1])) {
          temp = /\brv[ :]+(\d+)/g.exec(userAgent) || []
      
          return `IE ${temp[1] || ''}`
        }
      
        if (match[1] === 'Chrome') {
          temp = userAgent.match(/\b(OPR|Edge)\/(\d+)/)
      
          if (temp !== null) {
            return temp.slice(1).join(' ').replace('OPR', 'Opera')
          }
      
          temp = userAgent.match(/\b(Edg)\/(\d+)/)
      
          if (temp !== null) {
            return temp.slice(1).join(' ').replace('Edg', 'Edge (Chromium)')
          }
        }
      
        match = match[2] ? [ match[1], match[2] ] : [ navigator.appName, navigator.appVersion, '-?' ]
        temp = userAgent.match(/version\/(\d+)/i)
      
        if (temp !== null) {
          match.splice(1, 1, temp[1])
        }
      
        return match.join(' ')
      }

    const trackerVideo = (event) => {    
        if(typeof window !== "undefined"){
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
            'event': 'Video Play Btn',
            'formType': event,
            'formId': 'Video Play',
            'formName': 'Video',
            'formLabel': 'Video'
            });
        }
        
    }
      
     
    useEffect(()=>{
        if(!render){
            setRender(true) 
            if(saysWho().includes('Safari')) {
                setMuted(true) 
            } else{
                setMuted(false)
            }
        } 
    })
    return (
        <React.Fragment>
            {props.isOpen && 
                <div className="full-video">
                    {!isMobile && <div className="d-lg-block d-none">
                        <YouTube
                            onPlay={trackerVideo("popup video")}
                            videoId={props.videoId}
                            opts={{
                                height: "100%",
                                width: "100%",
                                playerVars: {
                                    autoplay: 1,
                                    disablekb: 1,
                                    controls: 0,
                                    mute: 0,
                                    rel: 0
                                }
                            }}
                        />
                    </div>}
                    {isMobile && <div className="d-lg-none d-block">
                        <ReactPlayer frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen
                            // autoplay
                            ref={vidRef} 
                            onPlay={trackerVideo(props.title)} 
                            url={`https://www.youtube.com/watch?v=${props.videoId}`} 
                            modestbranding="1"
                            muted={false}
                            controls={true}
                            playsinline={true}
                            // playing={props.isOpen}
                            onEnded={() => { props.stopPlay(false) }}
                            width='100vw' height='100vh'
                            previewTabIndex={0}
                            light={false}
                        />
                    </div>}
                </div>
            }
        </React.Fragment>
    )
};

export default React.memo(PlayVideo);